import { __decorate, __metadata } from 'tslib';
import { Injectable, NgModule } from '@angular/core';
import { ConfigOauthService, ApiService, UiBsOauthModule } from '@wlp/ui-bs-oauth';

let ConfigService = class ConfigService extends ConfigOauthService {
};
ConfigService = __decorate([
    Injectable()
], ConfigService);

const SPE_N_OPEN_ACCOUNT = '/spe-n-open-account';
let SpeNOpenAccountProxy = class SpeNOpenAccountProxy {
    constructor(api) {
        this.api = api;
    }
    login(login) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/login/account`;
        return this.api.post(uri, login);
    }
};
SpeNOpenAccountProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeNOpenAccountProxy);

const SPE_VIEW_N_ACCOUNT = '/spe-view-n-account';
let SpeViewNAccountProxy = class SpeViewNAccountProxy {
    constructor(api) {
        this.api = api;
    }
    getTypeAccount(uuidAccountPayment) {
        const uri = `${SPE_VIEW_N_ACCOUNT}/v1/account-payment-type/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
    getAccounts() {
        const uri = `${SPE_VIEW_N_ACCOUNT}/v1/access/accounts`;
        return this.api.get(uri);
    }
    personalDataContact() {
        const uri = `${SPE_VIEW_N_ACCOUNT}/v1/personal-data/contact/account-payment`;
        return this.api.get(uri);
    }
    personalDataUser() {
        const uri = `${SPE_VIEW_N_ACCOUNT}/v1/personal-data/user/account-payment`;
        return this.api.get(uri);
    }
    validateDevice(uuidDevicePhysical, uuidWhiteLabel) {
        const uri = `${SPE_VIEW_N_ACCOUNT}/v1/register-device/verify-device-and-enabled-module/${uuidDevicePhysical}/${uuidWhiteLabel}`;
        return this.api.get(uri);
    }
    getListDevices() {
        const uri = `${SPE_VIEW_N_ACCOUNT}/v1/register-device/find/account-payment-account-user`;
        return this.api.get(uri);
    }
    getPartnerDevices() {
        const uri = `${SPE_VIEW_N_ACCOUNT}/v1/register-device/list-device/account-payment/partner`;
        return this.api.get(uri);
    }
};
SpeViewNAccountProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeViewNAccountProxy);

const SPE_N_ACCOUNTS = '/spe-n-accounts';
let SpeNAccountsProxy = class SpeNAccountsProxy {
    constructor(api) {
        this.api = api;
    }
    changeAccount(uuidUserAccount) {
        const uri = `${SPE_N_ACCOUNTS}/v1/access/change`;
        return this.api.put(uri, null, null, [{ name: 'X-User-Account-ID', value: uuidUserAccount }]);
    }
    saveDevice(device) {
        const uri = `${SPE_N_ACCOUNTS}/v1/register-device`;
        return this.api.post(uri, device);
    }
    revokeDevice(uuidDevice) {
        const uri = `${SPE_N_ACCOUNTS}/v1/register-device/revoke-access-device/${uuidDevice}`;
        return this.api.post(uri, uuidDevice);
    }
    deviceAction(device) {
        const uri = `${SPE_N_ACCOUNTS}/v1/register-device/device-action`;
        return this.api.post(uri, device);
    }
    partnerActionsDevice(device) {
        const uri = `${SPE_N_ACCOUNTS}/v1/register-device/update-status`;
        return this.api.put(uri, device);
    }
    generateCodeSMS() {
        const uri = `${SPE_N_ACCOUNTS}/v1/register-device/validate/phone`;
        return this.api.post(uri);
    }
    generateCodeEmail() {
        const uri = `${SPE_N_ACCOUNTS}/v1/register-device/validate/email`;
        return this.api.post(uri);
    }
};
SpeNAccountsProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeNAccountsProxy);

let UiPxLoginModule = class UiPxLoginModule {
};
UiPxLoginModule = __decorate([
    NgModule({
        declarations: [],
        imports: [
            UiBsOauthModule
        ],
        providers: [SpeNOpenAccountProxy, SpeViewNAccountProxy, SpeNAccountsProxy, ConfigService]
    })
], UiPxLoginModule);

class RegisterDeviceDTO {
}

class DeviceActionDTO {
}

var DeletedEnum;
(function (DeletedEnum) {
    DeletedEnum["FALSE"] = "0";
    DeletedEnum["TRUE"] = "1";
})(DeletedEnum || (DeletedEnum = {}));

var TypeValidationEnum;
(function (TypeValidationEnum) {
    TypeValidationEnum["INTERNAL"] = "INTERNAL";
    TypeValidationEnum["IDUNICO"] = "IDUNICO";
})(TypeValidationEnum || (TypeValidationEnum = {}));

var DeviceStatusEnum;
(function (DeviceStatusEnum) {
    DeviceStatusEnum["BLOCK"] = "BLOCK";
    DeviceStatusEnum["LOSS"] = "LOSS";
    DeviceStatusEnum["THEFT"] = "THEFT";
    DeviceStatusEnum["REVOKED"] = "REVOKED";
    DeviceStatusEnum["UNLOCK"] = "UNLOCK";
    DeviceStatusEnum["ACTIVE"] = "ACTIVE";
})(DeviceStatusEnum || (DeviceStatusEnum = {}));

export { ConfigService, DeletedEnum, DeviceActionDTO, DeviceStatusEnum, RegisterDeviceDTO, SpeNAccountsProxy, SpeNOpenAccountProxy, SpeViewNAccountProxy, TypeValidationEnum, UiPxLoginModule };
//# sourceMappingURL=wlp-ui-px-login.js.map
